const PropTypes = require('prop-types');
const React = require('react');
const ReactCSSTransitionGroup = require('react-addons-css-transition-group');

function TransitionElement(props) {
  return (
    <ReactCSSTransitionGroup
      component={props.elementType}
      key="grid-view-list"
      className={props.classNames}
      transitionName="default-transition"
      transitionEnterTimeout={150}
      transitionLeaveTimeout={150}
    >
      {props.children}
    </ReactCSSTransitionGroup>
  );
}

TransitionElement.defaultProps = {
  elementType: 'div',
  classNames: '',
};

TransitionElement.propTypes = {
  children: PropTypes.node.isRequired,
  classNames: PropTypes.string,
  elementType: PropTypes.string,
};

module.exports = TransitionElement;



// WEBPACK FOOTER //
// ./javascripts/components/shared/transition_element.jsx